export enum DayClockingType {
  ERROR = 'error',
  FOR_MAN = 'for-man',
  FOR_EMP = 'for-emp',
  NIGHT_SHIFT = 'night_shift',
  NORMAL = 'normal'
}
